var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, makeObservable } from 'mobx';
import React from 'react';
import { observer } from 'mobx-react';
import { BrandingNextButtonCountdown } from './BrandingNextButtonCountdown';
let BrandingNextButton = class BrandingNextButton extends React.PureComponent {
    isNextButtonHovering = false;
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get nextColor() {
        if (this.isNextButtonHovering) {
            return 'rgba(255, 255, 255, 0.6)';
        }
        return 'rgba(255, 255, 255, 0.3)';
    }
    get nextBackground() {
        if (this.isNextButtonHovering) {
            return 'rgba(0, 0, 0, 0.5)';
        }
        return 'rgba(0, 0, 0, 0.3)';
    }
    get nextBorder() {
        if (this.isNextButtonHovering) {
            return '1px solid rgba(255,255,255,0.5)';
        }
        return '1px solid rgba(255,255,255,0.2)';
    }
    render() {
        const { question } = this.props;
        return (React.createElement("div", { style: {
                textShadow: '0 0 4px rgba(0,0,0,0.75)',
                display: 'flex',
                alignItems: 'center',
                background: this.nextBackground,
                border: this.nextBorder,
                color: this.nextColor,
                fontSize: 18,
                paddingLeft: 10,
                justifyContent: 'flex-end',
                boxSizing: 'content-box',
                height: 45,
                width: 220,
                letterSpacing: 1,
                cursor: 'pointer',
            }, onMouseEnter: action(() => (this.isNextButtonHovering = true)), onMouseLeave: action(() => (this.isNextButtonHovering = false)), onClick: question.context.app.directive.directivePoseQuestion.poseNextReward },
            React.createElement(BrandingNextButtonCountdown, { question: question }),
            React.createElement("span", { style: { whiteSpace: 'nowrap' } }, "Zur Belohnung"),
            React.createElement("i", { className: "fas fa-arrow-alt-to-right", style: { marginLeft: 10, fontSize: 22, marginRight: 10 } })));
    }
};
__decorate([
    observable
], BrandingNextButton.prototype, "isNextButtonHovering", void 0);
BrandingNextButton = __decorate([
    observer
], BrandingNextButton);
export { BrandingNextButton };
